import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialCustomerPageState,
  CustomerItemData,
  CustomerListStateType,
} from "../core/_model";
import { RoleSelectListResponse } from "../../../common/models/Roles";

export type ActionedCustomer = { data: CustomerItemData; action: ActionsKey };

type CustomerData = {
  customerList: any;
  detail: CustomerItemData | null;
  totalItems?: number;
  setDetail: (detail: CustomerItemData | null) => void;
  setCustomerList: (access: any) => void;
  actioned: ActionedCustomer | null;
  setActioned: (act: ActionedCustomer | null) => void;
  roleList: RoleSelectListResponse | null;
  setRoleList: (roles: RoleSelectListResponse | null) => void;
};

export const useCustomerStore = create<CustomerData>((set) => ({
  customerList: [],
  detail: null,
  setCustomerList: (mtl) =>
    set((state) => ({
      customerList: mtl?.member,
      totalItems: mtl?.totalItems,
    })),
  actioned: null,
  setActioned: (act) => set((state) => ({ actioned: act })),
  roleList: null,
  totalItems: 0,
  setRoleList: (customer) =>
    set(() => ({
      customerList: customer?.member,
      totalItems: customer?.totalItems,
    })),
  setDetail: (detail) => set((state) => ({ detail })),
}));

export const useCustomerListState = create<CustomerListStateType>((set) => ({
  pageState: initialCustomerPageState,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set({
      pageState: {
        page: 1,
        itemsPerPage: 10,
        pagination: true,
      },
    }),
}));
